import { Layout1, Layout2, Layout3, Layout4, Layout5, Layout6, Layout7 } from "../../components/layouts";
import { PlaylistTemplate } from "../../types";
import { LayoutProps } from "../../types/PlaylistsTypes";

export const templateComponentMap: Record<PlaylistTemplate, React.ComponentType<LayoutProps>> = {
    [PlaylistTemplate.Layout1]: Layout1 as React.ComponentType<LayoutProps>,
    [PlaylistTemplate.Layout2]: Layout2 as React.ComponentType<LayoutProps>,
    [PlaylistTemplate.Layout3]: Layout3 as React.ComponentType<LayoutProps>,
    [PlaylistTemplate.Layout4]: Layout4 as React.ComponentType<LayoutProps>,
    [PlaylistTemplate.Layout5]: Layout5 as React.ComponentType<LayoutProps>,
    [PlaylistTemplate.Layout6]: Layout6 as React.ComponentType<LayoutProps>,
    [PlaylistTemplate.Layout7]: Layout7 as React.ComponentType<LayoutProps>,
};  